import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImagePipe } from '../../pipes/image.pipe';
import { LiveViewPipe } from '../../pipes/live-view.pipe';
import { PrinterNamePipe } from '../../pipes/printerName.pipe';
import { PrinterStatusPipe } from '../../pipes/printerStatus.pipe';
import { StatePipe } from '../../pipes/state.pipe';
import { SharedModule } from '../shared.module';
import { BarControlViewerComponent } from './components/barcontrol-viewer/bar-control-viewer.component';
import { LaneControlViewerComponent } from './components/lanecontrol-viewer/lanecontrol-viewer.component';
import { PrinterViewerComponent } from './components/printer-viewer/printer-viewer.component';
import { EditVisitDialogComponent } from './dialogs/edit-visit/edit.component';
import { OpenBarDialogComponent } from './dialogs/openBar-dialog/openBar.dialog.component';
import { PrinterDialogComponent } from './dialogs/printer-dialog/printer.dialog.component';
import { BarControlComponent } from './pages/bar-control/bar-control.component';
import { LaneControlComponent } from './pages/lane-control/lane-control.component';
import { ListComponent } from './pages/list/list.component';
import { ControlModule } from './control.module';

const routes: Routes = [
  {
    path: '',
    component: LaneControlComponent,
    data: { animation: 'isLeft' },
  }
];

@NgModule({
  declarations: [
    ListComponent,
    LaneControlViewerComponent,
    LaneControlComponent,
    PrinterViewerComponent,
    PrinterStatusPipe,
    PrinterNamePipe,
    OpenBarDialogComponent,
    EditVisitDialogComponent,
    PrinterDialogComponent,
  ],
  imports: [RouterModule.forChild(routes), SharedModule, ControlModule],
  providers: [],
})
export class LaneControlModule {}
